/** When your routing table is too long, you can split it into small modules **/
const activeMenu = '/reportInfo'
const iconName = 'el-icon-s-data'
export default [
  //レポート
  {
    path: activeMenu,
    name: 'reportInfo',
    alwaysShow: true,
    component: () => import('@/layout/Layout'),
    redirect: '/reportInfo/reportInfoOverview',
    meta: {
      order: 500,
      icon: iconName,
      //ﾚﾎﾟｰﾄ
      permission: ['report'],
      title: 'resource.MENU.REPORT_TITLE'
    },
    children: [
      //個人売上実績レポート
      {
        path: 'annualSalesByUserReport',
        component: () => import('@/views/report/annualSalesByUserReport'),
        name: 'annualSalesByUserReport',
        alwaysShow: false,
        meta: {
          order: 501,
          icon: iconName,
          title: 'resource.master.annualSalesByUserReport',
          //角色：管理者
          permission:  ['report'],
        }
      },
        //個人受注実績レポート
        {
          path: 'annualNumberAndAcceptByUserReport',
          component: () => import('@/views/report/annualNumberAndAcceptByUserReport'),
          name: 'annualNumberAndAcceptByUserReport',
          alwaysShow: false,
          meta: {
            order: 502,
            icon: iconName,
            title: 'resource.master.annualNumberAndAcceptByUserReport',
            //角色：管理者
            permission:  ['report'],
          }
        },
      //得意先受注レポート
      {
        path: 'cusMOrderAmountReport',
        component: () => import('@/views/report/cusMOrderAmountReport'),
        name: 'cusMOrderAmountReport',
        alwaysShow: false,
        meta: {
          order: 503,
          icon: iconName,
          title: 'resource.master.cusMOrderAmountReport',
          //角色：管理者
          permission:  ['report'],
        }
      },
      //仕入先発注レポート
      {
        path: 'annualOrdersByUserReport',
        component: () => import('@/views/report/annualOrdersByUserReport'),
        name: 'annualOrdersByUserReport',
        alwaysShow: false,
        meta: {
          order: 504,
          icon: iconName,
          title: 'resource.master.annualOrdersByUserReport',
          //角色：管理者
          permission:  ['report'],
        }
      },
      //社内製造レポート
      {
        path: 'internalFactureReport',
        component: () => import('@/views/report/internalFactureReport'),
        name: 'internalFactureReport',
        alwaysShow: false,
        meta: {
          order: 505,
          icon: iconName,
          title: 'resource.master.internalFactureReport',
          //角色：管理者
          permission:  ['report'],
        }
      },
      // ADD 2026/03/06 Wjx 課題_260306顧客からの改善したい点への対応 start↓
      // 「年間売上実績」と「月間売上実績」を「ホーム」から「レポート」に移動
      // 「年間売上実績」と「月間売上実績」レポート
      {
        path: 'annualSalesPerformReport',
        component: () => import('@/views/report/annualSalesPerformReport'),
        name: 'annualSalesPerformReport',
        alwaysShow: false,
        meta: {
          order: 506,
          icon: iconName,
          title: 'resource.master.annualSalesPerformReport',
          //角色：管理者
          permission:  ['report'],
        }
      },
      // ADD 2026/03/06 Wjx 課題_260306顧客からの改善したい点への対応 end↑

    ]
  }
]

